import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $RadioButtonGroup = styled.div`
  margin-bottom: ${spacing('lg')};
`;
